import React from "react";
import Button from "../../common/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

const AddFaqModel = ({ open, handleClose, is_update }) => {
  return (
    <>
      <Dialog
        maxWidth={"xs"}
        open={open}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
      >
        <Stack
          spacing={2}
          sx={{ justifyContent: "center", alignItems: "center", p: 4.5 }}
        >
          <Typography
            sx={{ fontSize: "18px", fontWeight: "600", textAlign: "center" }}
          >
            {is_update ? "FAQ Updated Successfully" : "FAQ Added Successfully"}
          </Typography>
          <Button
            fullWidth
            variant="contained"
            onClick={() => handleClose()}
            children="Ok"
          />
        </Stack>
      </Dialog>
    </>
  );
};

export default AddFaqModel;
